import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Container, Image, Name, Description, Fee, LoaderWrapper, FeeSubText } from './vehicle.component.styles'
import { Loader } from '../../../component-library/components/loader/loader.component'
import { getCurrency } from '../../../service/currency.service'


const Vehicle = ({ image, name, description, extraDescription, fee, defaultFeeStyle, quoteInProgress, numberOfVehicles, feeSubText }) => {
  const [t] = useTranslation()
  const formatFee = defaultFeeStyle ? t('common__currency', { amount: fee }) : getCurrency({ amount: fee })

  return (
    <Container numberOfVehicles={numberOfVehicles} >
      <Image src={image} />
      <Name>{name}</Name>
      <Description quoteInProgress={quoteInProgress}>{description}</Description>
      {extraDescription && <Description>{extraDescription}</Description>}
      {quoteInProgress ? <LoaderWrapper><Loader /></LoaderWrapper> :
        <>
          <Fee defaultFeeStyle={defaultFeeStyle}>{t('text__body__minimum_fee', { fee: formatFee })}</Fee>
          {feeSubText && <FeeSubText>{feeSubText}</FeeSubText>}
        </>
      }

    </Container>
  )
}

Vehicle.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  extraDescription: PropTypes.string,
  fee: PropTypes.string.isRequired,
  defaultFeeStyle: PropTypes.bool,
  quoteInProgress: PropTypes.bool,
  numberOfVehicles: PropTypes.number,
  feeSubText: PropTypes.string
}

export { Vehicle }
